const CODE128_PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

export const Code128Barcode = ({ value, className = 'print-prescription-barcode' }: { value: string; className?: string }) => {
  const text = [...value].filter((char) => char.charCodeAt(0) >= 32 && char.charCodeAt(0) <= 126).join('');
  if (!text) return null;
  const symbols = [104, ...[...text].map((char) => char.charCodeAt(0) - 32)];
  const checksum = symbols.reduce((sum, code, index) => sum + code * (index || 1), 0);
  symbols.push(checksum % 103, 106);
  const widths = symbols.flatMap((symbol) => [...CODE128_PATTERNS[symbol] ?? ''].map(Number));
  let cursor = 0;
  const path = widths.map((width, index) => {
    const bar = index % 2 === 0 ? `M${cursor} 0h${width}v40h-${width}z` : '';
    cursor += width;
    return bar;
  }).join('');
  return (
    <svg
      className={className}
      viewBox={`0 0 ${cursor} 40`}
      preserveAspectRatio="none"
      role="img"
      aria-label={`Barcode ${text}`}
    >
      <path d={path} fill="#000" />
    </svg>
  );
};
